import { Switch } from '../../../Switch';

import { CellSwitch as CellSwitchStyled } from './CellSwitchStyled';

interface Props {
  enabled: boolean;
  onClick: (value: boolean) => void;
  disabled?: boolean;
}
export const CellSwitch = (props: Props) => {
  return (
    <CellSwitchStyled onClick={() => props.onClick(!props.enabled)} disabled={props.disabled}>
      <Switch isActive={props.enabled} />
    </CellSwitchStyled>
  );
};
